import { styled } from '@root/stitches.config';

export const BoxHeaderWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignContent: 'center',

  color: '$mainTextColor',
  span: {
    display: 'flex',
  },
});
export const BoxHeaderTitle = styled('div', {
  display: 'flex',
  alignItems: 'center',
});
export const ButtonWrapper = styled('div', {
  fontSize: '$14',
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: '$16',
  '@media (max-width: 768px)': {
    flexDirection: 'column',
    '& > *': {
      marginRight: '$12',
      marginBottom: '$8',
    },
  },
});

export const BoxDescription = styled('div', {
  fontSize: '$14',
  marginBottom: '$24',
});
